// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {Fragment, useContext, useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {Data_context} from './data_ctx';
import {use_pathname} from './lib/use_pathname';
import {use_translation_v} from './lib/trans_v';

const meta_map = {
    title: {tag: 'title', sel: {}},
    canonical_url: {tag: 'link', sel: {rel: 'canonical'}, attr: 'href'},
    description: {tag: 'meta', sel: {name: 'description'}, attr: 'content'},
    keywords: {tag: 'meta', sel: {name: 'keywords'}, attr: 'content'},
    og_description: {tag: 'meta', sel: {property: 'og:description'},
        attr: 'content'},
    og_title: {tag: 'meta', sel: {property: 'og:title'}, attr: 'content'},
    og_image: {tag: 'meta', sel: {property: 'og:image'}, attr: 'content'},
    og_url: {tag: 'meta', sel: {property: 'og:url'}, attr: 'content'},
    robots: {tag: 'meta', sel: {name: 'robots'}, attr: 'content'},
    author: {tag: 'meta', sel: {name: 'author'}, attr: 'content'},
    published_time: {tag: 'meta', sel: {property: 'article:published_time'},
        attr: 'content'},
};

// dmitriiz: our eslint doesn't know typedefinition and doesn't work with error
// 'Property' is defined but never used.
// type t_meta_description = {[Property in keyof typeof meta_map]?: string};
type t_meta_description = any;

const ensure_meta_tag = (tag, sel, attr, value)=>{
    if (tag=='title')
    {
        let prev = document.title;
        document.title = value;
        return ()=>document.title = prev;
    }
    let selector = [tag];
    for (let key in sel)
        selector.push(`[${key}="${sel[key]}"]`);
    let el = document.querySelector(selector.join(''));
    let created;
    if (!el)
    {
        el = document.createElement(tag);
        for (let key in sel)
            el.setAttribute(key, sel[key]);
        document.head.appendChild(el);
        created = true;
    }
    let prev = el.getAttribute(attr);
    if (prev==value)
        return;
    el.setAttribute(attr, value);
    return ()=>{
        if (created)
            el.remove();
        else
            el.setAttribute(attr, prev);
    };
};
const apply_meta = (meta?: t_meta_description)=>{
    if (!meta)
        return;
    let restore_fns = [];
    for (let key in meta)
    {
        let map = meta_map[key];
        if (!map)
        {
            console.error(`unknown meta: ${key}`);
            continue;
        }
        restore_fns.push(ensure_meta_tag(map.tag, map.sel, map.attr,
            meta[key]));
    }
    return ()=>restore_fns.forEach(fn=>fn && fn());
};

export const Meta = ({children, matched, props, routes, def_keywords,
def_description, overrided_meta}:any)=>{
    const {search} = useLocation();
    const {params, pathname} = use_pathname();
    const data = useContext(Data_context);
    const {t} = use_translation_v({no_defaults: true});
    useEffect(()=>{
        let meta = {} as t_meta_description;
        const is_us_region_page = pathname
            .includes('region');
        matched.forEach(r=>{
            let data_id = r.route && r.route.get_data_id ?
                r.route.get_data_id(params, pathname) : pathname;
            let data_from_provider = data[data_id] && [data[data_id].result];
            let r_meta = typeof r.route.meta=='function' ?
                r.route.meta({...props, data_from_provider, search, params,
                    translate: t,
                }) :
                r.route.meta;
            Object.assign(meta, r_meta);
        });
        if (!meta.keywords)
            meta.keywords = def_keywords;
        if (!meta.description && def_description
            && !is_us_region_page)
        {
            meta.description = def_description;
        }
        if (overrided_meta?.meta)
        {
            for (const key in overrided_meta.meta)
            {
                const value = overrided_meta.meta[key];
                if (value !== '' && value !== undefined && value !== null)
                    meta[key] = value;
            }
        }
        return apply_meta(meta);
    }, [routes, pathname, data, overrided_meta]);
    return <Fragment>
      {children}
    </Fragment>;
};
